import { TActivityUserActionLog } from "../../../context/ActivityProvider";
import { cn, formatdDate } from "../../../lib/utils";
import { TooltipCell } from "../../table/TooltipCell";

interface BodyTableUserActionsLogsProps {
  rows: TActivityUserActionLog[];
  isPagination?: boolean;
  isLoadingSendInvitation?: boolean;
  onRowClick?: (id: string) => void;
  handleClickInviteButton?: (id: string) => void;
}

export const BodyTableUserActionsLogs = ({
  rows,
}: BodyTableUserActionsLogsProps): JSX.Element => {
  const baseCellClassName = cn(
    "p-3 text-sm text-primary-light align-middle min-w-0 typo-body-small-medium-14"
  );

  return (
    <>
      {rows.map((activity, index) => (
        <tr key={activity?.id ?? index}>
          <td className={baseCellClassName}>
            <TooltipCell content={`${activity?.user?.first_name} ${activity?.user?.last_name}`} />
          </td>
          <td className={baseCellClassName}>
            <TooltipCell content={activity?.user?.email} />
          </td>
          <td className={baseCellClassName}>
            <TooltipCell content={activity?.action} />
          </td>
          <td className={baseCellClassName}>
            <TooltipCell content={activity?.action_key} />
          </td>
          <td className={baseCellClassName}>
            <TooltipCell content={formatdDate(activity?.created_stamp) || '-'} />
          </td>
          <td className={baseCellClassName}>
            <TooltipCell content={activity?.module_key} />
          </td>
        </tr>
      ))}
    </>
  );
};
